<template>
  <div class="page-container">
    <!-- Content Wrapper START -->
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Youtube Musics</h2>
        <div class="header-sub-title">
          <nav class="breadcrumb breadcrumb-dash">
            <router-link :to="`/`" class="breadcrumb-item">
              <i class="anticon anticon-home m-r-5"></i>Home >
            </router-link>
            <span class="breadcrumb-item active">Youtube Musics</span>
          </nav>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="m-t-25">
            <div class="row">
              <div class="col-lg-12 add-form mb-4 d-flex justify-content-end">
                <router-link :to="`/add-youtube-music`">
                  <button class="btn btn-info">Add New Music</button>
                </router-link>
              </div>
            </div>
            <section v-if="!isLoading">
              <div class="row">
                <div class="col-lg-12 add-form">
                  <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..."/>
                </div>
              </div>
              <table class="dataTable table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Artist</th>
                    <th>Duration</th>
                    <th>Link</th>
                    <th>Date Added</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="music in musics" :key="music.id">
                    <td>{{music.title}}</td>
                    <td>{{music.artist}}</td>
                    <td>{{music.duration}}</td>
                    <td> <a target="_blank" :href="music.link">Link</a></td>
                    <td>{{music.created_at}}</td>
                    <td>
                      <i class="fa fa-trash fa-icons" @click="deleteYoutubeMusic(music.id)" aria-hidden="true"></i>
                      <router-link :to="`/edit-youtube-music/` + music.id">
                        <i class="fas fa-pencil-alt fa-icons ml-md-1"></i>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </section>
            <div class="main-loader" v-else>
              <MainLoader></MainLoader>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Wrapper END -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import YoutubeMusic from '@/models/YoutubeMusic'
export default {
  name: 'YoutubeMusics',
  data () {
    return {
      datatable: null,
      musics: []
    }
  },
  computed: {
    isLoading () {
      if (this.musics.length === 0) { return this.$store.getters.apiStatus === 'loading' } else return false
    }
  },
  mounted () {
    let dataTableScript = document.createElement('script')
    dataTableScript.setAttribute('src', 'https://cdn.datatables.net/1.10.22/js/jquery.dataTables.min.js')
    document.head.appendChild(dataTableScript)

    let naturalScript = document.createElement('script')
    naturalScript.setAttribute('src', 'https://cdn.datatables.net/plug-ins/1.10.16/sorting/natural.js')
    document.head.appendChild(naturalScript)
    this.fetchAllYoutubeMusic()
  },
  methods: {
    fetchAllYoutubeMusic () {
      this.musics = []
      this.$store.dispatch('fetchAllYoutubeMusic')
        .then((result) => {
          result.data.youtubeMusics.forEach(music => {
            this.musics.push(new YoutubeMusic(music))
          })
          setTimeout(() => this.initDatatables(), 100)
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    deleteYoutubeMusic (id) {
      this.$confirm(
        {
          message: `Are you sure you want to delete this music?`,
          button: { no: 'No', yes: 'Yes' },
          callback: confirm => {
            if (confirm) {
              this.$store.dispatch('deleteYoutubeMusic', id)
                .then((result) => {
                  this.$toast.success(result.data.message)
                  this.fetchAllYoutubeMusic()
                })
                .catch((err) => this.$toast.error(err.response.data.message))
            }
          }
        }
      )
    },
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [
          {
            targets: 3,
            'orderable': false
          }
        ],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html("<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Youtube/YoutubeMusic.vue